<template>
  <div class="d-none" ref="ThreeCopyTemp">
    <div v-html="EjsData"></div>
    <!-- <div
      v-if="ticketDetails.length > 0"
      v-for="(item, itemIndex) in this.bookingDetails.seats_types"
      :key="itemIndex"
      :style="{ 'margin-bottom': '50px' }"
      style="page-break-after: always"
    >
      <div
        style="transform: rotate(90deg);display: table-cell; padding-bottom: 40px; padding-top: 35px"
      >
        <div class="print-tickets">
          <table border="0" style="width:410px;line-height:1; border:1px solid">
            <tr>
              <td colspan="3" style="padding:2px 10px;">
                <table style="width:100%">
                  <tr>
                    <td style="vertical-align:top;">
                      <p style="font-size:18px;font-weight:600;margin:0">P</p>
                    </td>
                    <td>
                      <p
                        style="font-size:14px;font-weight:600;margin: 0 0 5px 0"
                      >{{bookingDetails.cine_name}}, {{bookingDetails.cine_address}}</p>
                      <p
                        style="font-size:14px;font-weight:600;margin: 0;display: flex;justify-content: space-between;"
                      >
                        <span>{{ bookingDetails.movie_title }}</span>
                        <span
                          style="font-size: 12px; margin: 0px 0px 5px;letter-spacing: 0.3px;"
                        >Transaction No: {{ bookingDetails.sb_booking_code }}</span>
                      </p>
                      <span
                        style="font-size: 14px; margin: 0px 0px 5px;"
                      >Issued on: {{ new Date() | fulldatemonparse}}</span>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td style="width:33.33%;padding:2px 10px 2px 10px">
                <p style="font-size:16px;font-weight:600;margin:0;">
                  Total:
                  {{ totalAmount }} {{ getcurrency }}
                </p>
              </td>
              <td style="width:33.33%;padding:2px 10px 2px 10pxvertical-align:top;">
                <p
                  style="font-size:14px;font-weight:600;margin:0 0 5px 0;"
                >{{ bookingDetails.og_show_date | dayonly3 }}, {{ bookingDetails.og_show_date | dateparse }}</p>
                <p
                  style="font-size:14px;font-weight:600;margin:0 0 10px 0;"
                >{{ bookingDetails.og_show_time | timeparseAmPm }}</p>
              </td>
              <td style="width:33.33%; padding:2px 10px 2px 10px; vertical-align:top">
                <p
                  :style="{ 'font-size': '20px', 'font-weight': '600', 'padding': '5px 0px','margin':'0', 'border-bottom': '0'}"
                >{{bookingDetails.screen_name}}</p>
                <p
                  :style="{ 'font-size': '20px', 'font-weight': '600', 'padding': '5px 0px','margin':'0', 'border-bottom': '0'}"
                >{{ item.seatType.toUpperCase() }}: {{ item.seatName }}</p>
              </td>
            </tr>
          </table>
        </div>

        <hr style="border:1px dashed grey; margin:3px 0px" />

        <div class="print-tickets">
          <table border="0" style="width:410px;line-height:1;border:1px solid">
            <tr>
              <td colspan="3" style="padding:2px 10px;">
                <table style="width:100%">
                  <tr>
                    <td style="vertical-align:top;">
                      <p style="font-size:18px;font-weight:600;margin:0">D</p>
                    </td>
                    <td>
                      <p
                        style="font-size:14px;font-weight:600;margin: 0 0 5px 0"
                      >{{bookingDetails.cine_name}} , {{bookingDetails.cine_address}}</p>
                      <p
                        style="font-size:14px;font-weight:600;margin: 0;display: flex;justify-content: space-between;"
                      >
                        <span>{{ bookingDetails.movie_title }}</span>
                        <span
                          style="font-size: 12px; margin: 0px 0px 5px;letter-spacing: 0.3px;"
                        >Transaction No: {{ bookingDetails.sb_booking_code }}</span>
                      </p>
                      <span
                        style="font-size: 14px; margin: 0px 0px 5px;"
                      >Issued on: {{ new Date() | fulldatemonparse}}</span>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td style="width:33.33%;padding:2px 10px 2px 10px">
                <p style="font-size:16px;font-weight:600;margin:0;">
                  Total:
                  {{ totalAmount }} {{ getcurrency }}
                </p>
              </td>
              <td style="width:33.33%;padding:2px 10px 2px 10pxvertical-align:top;">
                <p
                  style="font-size:14px;font-weight:600;margin:0 0 5px 0;"
                >{{ bookingDetails.og_show_date | dayonly3 }}, {{ bookingDetails.og_show_date | dateparse }}</p>
                <p
                  style="font-size:14px;font-weight:600;margin:0 0 10px 0;"
                >{{ bookingDetails.og_show_time | timeparseAmPm }}</p>
              </td>
              <td style="width:33.33%; padding:2px 10px 2px 10px; vertical-align: top">
                <p
                  :style="{ 'font-size': '20px', 'font-weight': '600', 'padding': '5px 0px','margin':'0', 'border-bottom': '0'}"
                >{{bookingDetails.screen_name}}</p>
                <p
                  :style="{ 'font-size': '20px', 'font-weight': '600', 'padding': '5px 0px','margin':'0', 'border-bottom': '0'}"
                >{{ item.seatType.toUpperCase() }}: {{ item.seatName }}</p>
              </td>
            </tr>
          </table>
        </div>

        <hr style="border:1px dashed grey; margin:3px 0px" />

        <div class="print-tickets">
          <table border="0" style="width:410px;line-height:1;border:1px solid">
            <tr>
              <td colspan="3" style="padding:2px 10px;">
                <table style="width:100%">
                  <tr>
                    <td style="vertical-align:top;">
                      <p style="font-size:18px;font-weight:600;margin:0">H</p>
                    </td>
                    <td>
                      <p
                        style="font-size:14px;font-weight:600;margin: 0 0 5px 0"
                      >{{bookingDetails.cine_name}} , {{bookingDetails.cine_address}}</p>
                      <p
                        style="font-size:14px;font-weight:600;margin: 0;display: flex;justify-content: space-between;"
                      >
                        <span>{{ bookingDetails.movie_title }}</span>
                        <span
                          style="font-size: 12px; margin: 0px 0px 5px;letter-spacing: 0.3px;"
                        >Transaction No: {{ bookingDetails.sb_booking_code }}</span>
                      </p>
                      <span
                        style="font-size: 14px; margin: 0px 0px 5px;"
                      >Issued on: {{ new Date() | fulldatemonparse}}</span>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
            <tr>
              <td style="width:33.33%;padding:2px 10px 2px 10px;">
                <p style="font-size:16px;font-weight:600;margin:0;">
                  Total:
                  {{ totalAmount }} {{ getcurrency }}
                </p>
              </td>
              <td style="width:33.33%;padding:2px 10px 2px 10px;vertical-align:top;">
                <p
                  style="font-size:14px;font-weight:600;margin:0 0 5px 0;"
                >{{ bookingDetails.og_show_date | dayonly3 }}, {{ bookingDetails.og_show_date | dateparse }}</p>
                <p
                  style="font-size:14px;font-weight:600;margin:0 0 10px 0;"
                >{{ bookingDetails.og_show_time | timeparseAmPm }}</p>
              </td>
              <td style="width:33.33%;padding:2px 10px 2px 10px; vertical-align: top">
                <p
                  :style="{ 'font-size': '20px', 'font-weight': '600', 'padding': '5px 0px','margin':'0', 'border-bottom': '0'}"
                >{{bookingDetails.screen_name}}</p>
                <p
                  :style="{ 'font-size': '20px', 'font-weight': '600', 'padding': '5px 0px','margin':'0', 'border-bottom': '0'}"
                >{{ item.seatType.toUpperCase() }}: {{ item.seatName }}</p>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import Printd from "printd";
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import PosService from "@/services/PosService";
import moment from "moment";
import { EventBus } from "@/main";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  props: {
    ticketDetails: {
      type: Array
    }
  },
  data() {
    return {
      EjsData: null
    };
  },
  computed: {
    isReprint() {
      return this.$store.getters.isReprint;
    },
    bookingDetails() {
      return this.$store.getters.BOOKING_DETAILS;
    },
    AdditionalCharges() {
      return this.$store.getters.ADDITIONAL_CHARGES;
    },
    getSelectedArray() {
      let array = [];
      if (
        this.bookingDetails &&
        this.bookingDetails["seats_types"] &&
        this.bookingDetails["seats_types"].length > 0
      ) {
        this.bookingDetails.seats_types.map(x => {
          x.seats.map(y => {
            array.push({
              seatName: y,
              seatType: x.seat_type
            });
          });
        });
      }
      return array;
    },
    totalAmount() {
      return this.getOfferPrice > 0
        ? this.$store.getters.TOTAL_AMOUNT - this.getOfferPrice
        : this.$store.getters.TOTAL_AMOUNT;
    },
    netAmount() {
      return this.$store.getters.NET_AMOUNT;
    },
    getcurrency() {
      return this.$store.getters.GET_CURRENCY;
    },
    ...mapGetters([
      "getOfferPrice",
      "getSelectedOffer",
      "getOfferFor",
      "IDforBoxOfficeEjs"
    ])
  },
  mounted() {
    EventBus.$on("printThreeCopyTemp", () => {
      // this.print();
      this.GetEjsTicket();
    });
  },
  beforeDestroy() {
    //after called $on event destroy that event to do not call function multiple times
    EventBus.$off("printDefaultTemp");
  },
  methods: {
    calculateTicketPrice(value) {
      return value
        ? parseFloat(parseFloat(value) - parseFloat(this.offerPrice)).toFixed(this.MIN_FRACTION_DIGITS)
        : 0;
    },
    GetEjsTicket: function() {
      let loader = this.$loading.show();

      PosService.GetTicketEjs(
        this.IDforBoxOfficeEjs.sb_id,
        this.IDforBoxOfficeEjs.cinema_id,
        this.isReprint
      )
        .then(response => {
          const { data } = response;

          this.EjsData = data;

          this.$nextTick(() => {
            loader.hide();
            this.print();
          });
        })
        .catch(this._CatchError);
      // .finally(() => {
      //   setTimeout(() => loader.hide(), 1000);
      // });
    },
    print: function() {
      const p = new Printd();
      if (this.$refs.ThreeCopyTemp) {
        p.print(this.$refs.ThreeCopyTemp, []);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/PosBookingContainer/PrintTicketTemplates/3_Copies_Template.vue